import React from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Form} from "semantic-ui-react";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import {Empty} from "antd";
import {MDBDataTable} from "mdbreact";
import * as common from "../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import axios_eventtag from "../../../../axios/axios_eventtag";
import apiConfig from "../../../../axios/axios_api_services";
import {connect} from "react-redux";
import * as actionCreator from "../../../../store/Action";
import * as timeutils from "../../../../util/TimeConvertor";

class App extends React.Component{
  state = {
    eventList: [],
    subEventOptionList: [],
    startDate: "",
    endDate: "",
    notifications: [],
    subEventId: "",
    notificationList: [
      // {
      //   "notification_id": 1,
      //   "title": "Inform about new service category",
      //   "body": "We proudly introduce new service named ABC for Sri Lankans to improve their knowledge to next level",
      //   "type": "EVENT",
      //   "time": "2020-11-10 13:00:00",
      //     "type": "event",
      //     "firebase_id": 9990999,
      // },
      // {
      //   "notification_id": 2,
      //   "title": "Inform about new service category",
      //   "body": "We proudly introduce new service named DEF for Sri Lankans to improve their knowledge to next level",
      //   "type": "EVENT",
      //   "time": "2020-11-10 13:00:00",
      //     "type": "event",
      //     "firebase_id": 9990999,
      // }
           ]	,
  };

  componentDidMount() {
    this.getAllEvents();
  }

  getAllEvents = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(async response => {
        if (response.data.success) {
          this.setState({
            eventList: response.data.eventList,
          });
          this.props.spinnerHandler(false);
        }
      }).catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.getAllEvents();
      } else {
        this.props.spinnerHandler(false)
      }
    })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  getSubEvents = (e, {value}) => {
    this.setState({notifications:[]});

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let eventid = value ;
    axios_eventtag.get(apiConfig.GET_SUBEVENT({event_id: eventid, corporateId: corporateId}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            subEventOptionList: response.data.subEventList,
            subEventId: ""
          });
        } else {
          this.setState({
            subEventOptionList: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubEvents(e, {value});
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  getNotification = (e, {value}) => {
    // this.setState({
    //   notifications: this.props.notification
    // })

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axios_eventtag.get(apiConfig.DISPLAY_NOTIFICATIONS({sub_event_id:value, corporateId: corporateId}), {headers: headers})
    .then(response => {
      if(response.data.success) {
        this.setState({
          notifications: response.data.content.notificationsList,
          subEventId: value
        })
      }else{
       this.setState({
        notifications: []
       })
      }
    })
    .catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.getSubEvents();
      }
    })
    .finally(fin => {
      this.props.spinnerHandler(false);
    });
  }

  render() {
    let events = [];

    if (this.state.eventList.length !== 0) {
      this.state.eventList.map((value, index) => {
        events.push({
          text: value.event_name,
          value: value.event_id,
          key: value.event_id,
          hassub: value.has_sub_event === true ? 1:0,
          starttime: value.start_time
        })
      })
    }

    let subEventList = [];
    if(this.state.subEventOptionList.length !== 0){
      this.state.subEventOptionList.map((value, index) => {
        subEventList.push({
            text: value.name,
            value:value.sub_event_id,
            key: value.sub_event_id
          });
      });
    }

    let notificationRows = [];
    let columns = this.props.table_data.columns

    if(this.state.notifications.length !== 0){
      this.state.notifications.map((value, index) => {
        notificationRows.push({
          time: timeutils.YYYYMMDDHHMMSSUTCToLocalDateTime(value.time + ":00"),
          title: value.title,
          description: value.body
          // description:<div><Row style={{marginLeft:"2px"}}>{value.title}</Row>
          //                   <Row style={{marginLeft:"2px"}}>{value.body}</Row></div>
        })
      })
    }

    return(
      <div>
        <Row>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Filter Event
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg ={4}>
                      <Form.Group widths='equal'>
                        <DrpDwn
                          // required
                          tagText={"Select Event"}
                          placeholder={"Select event"}
                          // value={this.state.category}
                          options={events}
                          onChange={this.getSubEvents}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg ={4}>
                      <Form.Group widths='equal'>
                        <DrpDwn
                          required
                          tagText={"Select Sub-Event"}
                          placeholder={"Select sub-event"}
                          defaultValue ={1}
                          value={this.state.subEventId}
                          options={subEventList}
                          onChange={this.getNotification}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Notifications
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg ={12} md={12}>

                      {
                        this.state.notifications.length !== 0 ?
                          <MDBDataTable
                            searching={false}
                            displayEntries={true}
                            paging={false}
                            entries={0}
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            bordered
                            hover
                            // columns={columns}
                            // rows={notificationRows}
                            data={{rows:notificationRows,columns:columns}}
                          />
                          : <div className={"align-center fully-width"}>
                            <Empty description={"Records not found"} className={"empty-icon"}/>
                          </div>

                      }
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

}


const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  test_alleventobject: state.eventReducer.allEventsObj,
  notification:state.notificationReducer.allnotificationobj.notificationList,
  table_data: state.notificationReducer.notification_table
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
